import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'heading-xl mb-1',
    description: 'heading-m mb-6',
    field: '',
    ratingContainer: '-mx-1 flex',
    starButton:
      'text-icon-secondary-medium hover:text-icon-star relative inline-block cursor-pointer px-1 transition-colors',
    starIcon: 'size-10',
    starFilled:
      'text-icon-star pointer-events-none absolute top-0 left-1 overflow-hidden',
    error: 'heading-s text-error mt-1'
  }
});
